import { AuthContext, FireactContext, SetPageTitle } from "../lib/core";
import { Alert, Box, Button, Card, CardActions, CardHeader, Container, Paper, Typography, styled, TextField } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid2';
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/system";
import { collection, query, where, getDocs, getDoc, doc, limit } from 'firebase/firestore';
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import {PageSection} from "../template/TemplateElements";
import Footer from "../template/Footer";
import VimeoPlayer from "../template/VimeoPlayer";
import Hero from "./GraphQL/Hero";
import SpaceX from "./GraphQL/SpaceX";
import NFT from "./GraphQL/NFT";
import Matching from "./Matching";
import {APIProvider, Map, Marker, useMapsLibrary, useMap, createMarker} from '@vis.gl/react-google-maps';
import {QueryAddress, PlaceAutocomplete} from "./google_maps/MapComponents";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import { green } from '@mui/material/colors';
import {AppContext} from './common/AppContext';

const Home = ({loader}) => {

    const { authInstance, firestoreInstance, functionsInstance } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const {currentAddress, setCurrentAddress} = useContext(AppContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const { authUser } = useContext(AuthContext);
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('sm'));

    const currentCircle = useRef(null);

    useEffect(() => {
        setLoaded(false);
        setError(null);
        // get default permission level name
        let defaultPermission = '';
        for(var permission in config.saas.permissions){
            const value = config.saas.permissions[permission];
            if(value.default){
                defaultPermission = permission;
            }
        }

        setLoaded(true);
        
    },[authInstance, config.saas.permissions, firestoreInstance]);
    // LA 34.054908,-118.242643
    // Vancouver 49.2827291 -123.1207375
    //const position = {lat: 49.2827291, lng: -123.1207375};
    //const [position, setPosition] = useState({lat: 34.054908, lng: -118.242643});
    const [position, setPosition] = useState(null);
    const setMarker = (lat, lng) => {
      setPosition({lat: lat, lng: lng});
    }
    const [addressEntered, setAddressEntered] = useState('');
    const [defaultAddress, setDefaultAddress] = useState('');
    const [loading, setLoading] = useState(false);

    const updateAutoCompletedAddress = (address) => {
      setAddressEntered(address);
      setCurrentAddress(address);
      console.log('set current address ', address);
      setDefaultAddress('');
    }

    const getLocation = () => {
      if (navigator.geolocation) {
        setLoading(true);
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setPosition({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
            /*
            console.log('location ', {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
            */
            getAddress(position.coords.latitude, position.coords.longitude);
          },
          (error) => {
            setLoading(false);
            switch (error.code) {
              case error.PERMISSION_DENIED:
                setError("User denied the request for Geolocation.");
                break;
              case error.POSITION_UNAVAILABLE:
                setError("Location information is unavailable.");
                break;
              case error.TIMEOUT:
                setError("The request to get user location timed out.");
                break;
              default:
                setError("An unknown error occurred.");
                break;
            }
          }
        );
      } else {
        setError("Geolocation is not supported by this browser.");
      }
    };

    const getAddress = async (latitude, longitude) => {
      const apiKey = "AIzaSyBDB3_zlIS4f6qxog7HrvJCJ31rnQnBxxk";
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;
  
      try {
        const response = await fetch(url);
        const data = await response.json();
        setLoading(false);
        if (data.results && data.results.length > 0) {
          setDefaultAddress(data.results[0].formatted_address);
          setCurrentAddress(data.results[0].formatted_address);
          console.log('set current address ', data.results[0].formatted_address);
          //console.log('address', data.results[0].formatted_address)
        } else {
          setError("No address found for the given coordinates.");
        }
      } catch (err) {
        setError("Error fetching address: " + err.message);
      }
    };

    return (
        <>
            {loaded ? (
                <Container maxWidth={false} disableGutters>
                    <SetPageTitle title="IV Services" />
                         <Box
                        sx={{
                            backgroundImage: "url('/header.jpg'), linear-gradient(to bottom left, #C5ECE0, #40B5A8)",
                            backgroundPosition: 'top center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            maxHeight: '285px',
                            height: '285px',
                            width: '100%',
                            color: '#042027'
                            }}
                        >
                        <Stack spacing={0} justifyContent="center" alignItems="center" sx={{height: '100%'}}>
                            
                            <Typography component="div" variant="h3" align="center" sx={{p:2, fontSize: {xs: '30px', md: '40px'}}}>
                            Discover IV Services in Your Area
                            </Typography>
                            <Typography component="div" variant="h4" align="center" sx={{pt:0,pb:2, fontSize: {xs: '20px', md: '30px'}}}>
                            Book personalized IV treatments designed to support hydration, energy, and overall well‑being—delivered at home by licensed nurses.
                            </Typography>
                            
                        </Stack>
                     </Box>
                     <Box sx={{ flexGrow: 1, px: 2, py: 0, width: '100%', minHeight: '100vh'}} >
                     {authUser.user && authUser.userType === "Nurse" ? (
                      <>
                        Please log in as a Customer to access the services.
                      </>) : (
                      <>
                        <Grid container spacing={0}>
                          <Grid size={{ xs: 12, md: 12 }}>
                          <APIProvider apiKey={'AIzaSyBDB3_zlIS4f6qxog7HrvJCJ31rnQnBxxk'}>
                            <PageSection>
                              <Grid container spacing={0}>
                                {/*<Grid size={{ xs: 12, md: 12 }}>
                                <Box sx={{minHeight: '400px', height: '100%'}}>
                                  <Map center={position} zoom={10} disableDefaultUI={true} scrollwheel={false} gestureHandling={'none'} keyboardShortcuts={false}>
                                  <Marker position={position} />
                                  </Map>
                                  <QueryAddress setMarker={setMarker} currentCircle={currentCircle} />
                                </Box>
                                </Grid>*/}
                                <Grid size={{ xs: 12, md: 12 }} sx={{px: {xs:0, md:2}}}>
                                  <PlaceAutocomplete setMarker={setMarker} currentCircle={currentCircle} showCircle={false} setAddressEntered={updateAutoCompletedAddress} label={`Enter your address for available services`} defaultAddress={defaultAddress}/>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12 }} sx={{py: 2, px: {xs:0, md:2}}}>
                                  <LoadingButton
                                      onClick={getLocation}
                                      loading={loading}
                                      loadingPosition="start"
                                      startIcon={<LocationSearchingIcon />}
                                      variant="outlined"
                                  >
                                      <span>Use My Current Address</span>
                                  </LoadingButton>
                                </Grid>
                              </Grid>
                            </PageSection>
                          </APIProvider>
                          </Grid>
                          <Grid size={{ xs: 12, md: 12 }}>
                            {position ? (
                              <Matching position={position}/>
                            ) : (
                              <PageSection>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{ m: {xs: 0, md: 2}, p: 2, backgroundColor: 'primary.main', borderRadius: 1 }}
                              >
                                <Typography variant='h6'>Please enter your address to start searching for available services around you.</Typography>
                              </Box>
                              </PageSection>
                            )}
                          </Grid>
                          {/*
                          <Grid size={{ xs: 12, md: 4 }}>
                            <PageSection>
                              <VimeoPlayer embedId="606276910" />
                            </PageSection>
                          </Grid>
                          */}
                          <Grid size={{ xs: 12, md: 12 }}>
                            <Grid container spacing={0}>
                                <Grid size={{ xs: 12, md: 4 }}>
                                  <PageSection>
                                    
                                  </PageSection>
                                </Grid>
                            </Grid>
                          </Grid>
                          <Grid size={{ xs: 12, md: 12 }}>
                          <PageSection>
                            
                          </PageSection>
                          </Grid>
                        </Grid>
                      </>
                     )}
                    </Box>
                    <Footer />
                </Container>
            ):(
                <>{loader}</>
            )}
        </>
    )
}

export default Home;
